// Module
var code = "<div class=\"table-chart-options\"> <template v-if=\"clientData != null\"> <popover @open=\"toggleHeatmap()\"> <a href=\"#\" class=\"strong\" data-id=\"toggle-heatmap\"> Heatmap <span :class=\"{ '-heatmap-on' : options.heatMap }\">{{ options.heatMap ? 'On' : 'Off' }}</span> </a> </popover> </template> </div> ";
// Exports
export default code;